import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  peoplePageHeader: {
    padding: "0 0 26px 0px"
  },
  titleWrapper: {
    display: "flex"
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0 0 0 12px",
    margin: "0px"
  },
  defaultBadge: {
    color: theme.tooltip.styleTwo.color,
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    backgroundColor: theme.tooltip.styleTwo.backgroundColor,
    padding: "4px 12px",
    borderRadius: "16px",
    height: "100%",
    margin: "auto 0px auto 12px"
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      justifyContent: "flex-start",
      marginTop: "12px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      justifyContent: "flex-start",
      display: "grid"
    },
  },
  btnsDiv: {
    display: "flex"
  },
  pendingInvitesNr: {
    fontSize: "10px",
    backgroundColor: colors.mediumBlue,
    borderRadius: "50%",
    color: colors.darkBlue,
    width: "20px",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 0 0 5px"
  },
  pendingInvitesBtn: {
    marginRight: "11px",
    padding: "10px 16px",
    height: "40px",
    alignItems: "center",
    "& :focus-visible": {
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "& span": {
      whiteSpace: "nowrap"
    }
  },
  invBtn: {
    height: "40px",
    alignItems: "center",
    "& span": {
      whiteSpace: "nowrap"
    }
  },
  makeDefaultBtn: {
    marginRight: "11px",
    color: colors.mediumGrey,
    backgroundColor: "transparent !important",
    border: "none",
    "&:hover": {
      color: colors.grey,
      transitionDuration: "200ms"
    },
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      paddingLeft: "4px"
    },
  },
  makeDefaultDisabledBtn: {
    pointerEvents: "none",
    marginRight: "11px",
    color: colors.darkGrey,
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      paddingLeft: "4px"
    },
  },
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
  popoverStyle:{
    "& .popover-arrow": {
      display: "none !important",
    },
  },
  popoverDiv:{
    position: 'absolute',
    alignItems:"center",
    backgroundColor: '#FFFFFF',
    padding: '6px',
    width:"240px",
    border: "1px solid #EAECF0",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    borderRadius: 8,
    color: colors.grey,
    translate:"782px, 64px",
    '& span': {
      display: "block"
    }
  },
  dotsStyle:{
    display:"flex",
    alignItems:"center",
    marginRight:"12px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      display: "none"
    }
  },
  popoverItem: {
    fontSize: "14px",
    fontWeight: "500",
    color: colors.grey,
    padding: "10px",
    cursor: "pointer",
    "&:hover": {
      background: colors.brightBlue
    }
  },
}));

export default styles;
